/**
 * Vertical nested menu.
 */
const menu_nested_vertical = (args) => {
    // setup args
    let menu = args.menu;

    // validate
    if (!menu) {
        // console.log('Invalid vertical nested menu args');
        return;
    }

    // require tools
    if (typeof window.nested_menu_tools === 'undefined') {
        // console.log('Nested menu tools undefined');
        return;
    }

    function init() {
        // console.log('init vertical nested menu');

        /**
         * Open current-menu-item ancestors.
         */
        const currentMenuItem = menu.querySelector('.current-menu-item');
        if (currentMenuItem) {
            const ancestors = window.nested_menu_tools.getAllAncestors(
                menu,
                currentMenuItem,
                'menu-item-has-children'
            );
            ancestors.forEach((ancestor) => {
                window.nested_menu_tools.activateMenuItem(menu, ancestor);
            });
        }
    }

    init();

    // make the call chainable
    return this;
};

document.querySelectorAll('.js-menu-nested-vertical').forEach((menu) => {
    menu_nested_vertical({
        menu: menu,
    });
});
